<template>
  <div>
    <QS-h4-title
      title="商品标签"
    >
      <template #content>
        建议用于商品特性的描述词语，在商品列表展示，最多可添加<span>{{TAGS_MAX_LENGTH}}</span>个标签（示例：
        <el-button
          v-for="(quickTag, index) in quickTags"
          :key="index"
          @click="addTag(quickTag)"
          type="text"
        >
          {{ quickTag }}
        </el-button>
        等）
      </template>
    </QS-h4-title>
    <el-form label-width="120px">
      <el-form-item :label="'已添加标签'+ columnSeparator">
        <div v-if="isDetail">
          <el-tag
            class="good_tag"
            v-for="(checkedTag, index) in dragTagList"
            :key="index"
          >{{ checkedTag }}</el-tag>
        </div>
        <div v-else>
          <el-tag
            class="good_tag"
            @close="handleClose(checkedTag)"
            v-for="(checkedTag,index) in dragTagList"
            :key="index"
            closable
          >
            {{ checkedTag }}
          </el-tag>
          <el-button
            v-if="!isDetail && dragTagList.length < TAGS_MAX_LENGTH"
            type="text"
            size="mini"
            @click="toggleDialogVisible(true)"
          >添加标签</el-button>
        </div>
      </el-form-item>
    </el-form>

    <!-- 添加标签弹窗 -->
    <el-dialog
      title="添加标签"
      :visible.sync="dialogVisible"
      width="350px"
    >
      <el-form
        :model="tagForm"
        :rules="tagRules"
        ref="tagForm"
        label-width="70px"
      >
        <el-form-item
          label="标签："
          prop="inputTabValue"
        >
          <QSCheckTextInput
            v-if="dialogVisible"
            v-model="tagForm.inputTabValue"
            maxlength="5"
            :request="request"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="toggleDialogVisible(false)">取 消</el-button>
        <el-button
          type="primary"
          @click="addTag()"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { carryFirst } from '@/utils'

const TAGS_MAX_LENGTH = 5
export default {
  name: 'tagList',
  data() {
    const validateTag = (rule, value, callback) => {
      callback(this.validateTag(value))
    }

    const validateLength = (rule, value, callback) => {
      if (value.length > 5) {
        callback(new Error('内容长度为5'))
      } else {
        callback()
      }
    }
    return {
      request,
      tagRules: {
        inputTabValue: [
          { required: true, validator: validateTag, trigger: 'blur' },
          { required: true, validator: validateLength, trigger: 'change' },
        ],
      },
      dragTagList: [], // 可拖拽标签集合
      quickTags: ['准新车', '空间大', '长续航', '带天窗'], // 快捷tag，点击后直接添加
      dialogVisible: false,
      tagForm: {
        inputTabValue: '', // 输入框添加的标签值
      },
      TAGS_MAX_LENGTH,
    }
  },
  props: ['isDetail', 'tags'],
  watch: {
    tags: {
      handler(val) {
        this.dragTagList = val
      },
      deep: true,
      immediate: true,
    },
    dialogVisible() {
      // 清空弹窗的输入框
      this.tagForm.inputTabValue = ''
    },
  },
  methods: {
    // 关闭标签
    handleClose: carryFirst(function (tag) {
      const h = this.$createElement
      this.$msgbox({
        title: '删除标签',
        message: h('p', null, [
          h('span', null, '删除标签后，商城车型列表不再展示该标签'),
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.dragTagList.splice(this.dragTagList.findIndex((item) => item === tag), 1)
      })
    }, function (tag) {
      this.dragTagList.splice(this.dragTagList.findIndex((item) => item === tag), 1)
    }, 60000),
    addTag(tag) {
      if (tag) {
        this.addQuickTag(tag)
      } else {
        this.addFormTag()
      }
    },
    addFormTag() {
      this.$refs.tagForm.validate((valid) => {
        if (!valid) return
        this.toggleDialogVisible(false)
        this.dragTagList.push(this.tagForm.inputTabValue)
      })
    },
    addQuickTag(tag) {
      const err = this.validateTag(tag)
      if (err) {
        return this.$message.error(err.message)
      }
      this.dragTagList.push(tag)
    },
    validateTag(tag) {
      if (!tag) {
        return new Error('标签内容不能为空')
      }
      if (tag.length > 5) {
        return new Error('标签内容长度最大为5')
      }
      if (this.dragTagList.length >= TAGS_MAX_LENGTH) {
        return new Error(`最多添加${TAGS_MAX_LENGTH}个标签`)
      }
      if (this.dragTagList.includes(tag)) {
        return new Error('已存在相同标签')
      }
    },
    toggleDialogVisible(show) {
      if (show) {
        this.$refs.tagForm?.clearValidate()
      }
      this.dialogVisible = show
    },
  },
}
</script>

<style lang="scss" scoped>
.good_tag {
  margin-right: 10px;
  padding: 6px 8px;
  cursor: pointer;
}
</style>
